export default "__VITE_ASSET__CzK5L8xP__"